// src/composables/useLoading.js
import { ref, computed } from 'vue'

// 1. 定义在模块作用域，保证全局唯一
const loadings = ref([])

const DEFAULT_TIMEOUT = 60000      // 默认超时时间：60秒
const DEFAULT_DELAY = 200          // 默认延迟展示：200ms，避免闪烁
const DEFAULT_MIN_DURATION = 500   // 默认最小展示时间：500ms，避免过早消失

const show = (options = {}) => {
    const id = options.id || Date.now()
    const delay = options.delay ?? DEFAULT_DELAY
    const timeout = options.timeout ?? DEFAULT_TIMEOUT
    const minDuration = options.minDuration ?? DEFAULT_MIN_DURATION

    let resolveId
    const promise = new Promise((resolve) => {
        resolveId = resolve
    })

    const addLoading = () => {
        const loading = {
            id,
            message: options.message || 'loading...',
            overlay: options.overlay ?? true,
            minDuration,
            addedAt: Date.now()
        }

        loadings.value.push(loading)

        if (timeout > 0) {
            setTimeout(() => {
                hide(id)
            }, timeout)
        }
        resolveId(id)
    }

    if (delay > 0) {
        setTimeout(addLoading, delay)
    } else {
        addLoading()
    }

    return promise
}

const hide = (id) => {
    const index = loadings.value.findIndex(l => l.id === id)
    if (index === -1) return

    const loading = loadings.value[index]
    const elapsed = Date.now() - loading.addedAt

    if (elapsed < loading.minDuration) {
        setTimeout(() => hide(id), loading.minDuration - elapsed)
        return
    }

    loadings.value.splice(index, 1)
}

const clear = () => {
    loadings.value = []
}

const isActive = computed(() => loadings.value.length > 0)
const current = computed(() => loadings.value[loadings.value.length - 1] || null)

// 2. useLoading 返回同一个对象
export const useLoading = () => ({
    loadings,
    show,
    hide,
    clear,
    isActive,
    current
})